angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryModelsSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'models';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);